import type { CSSProperties } from "react";
import Image404 from "@/assets/404-image.svg";

const illustrationStyle: CSSProperties = {
  display: "block",
  width: "100%",
  maxWidth: "480px",
  height: "auto",
  aspectRatio: "480 / 337",
  objectFit: "contain",
  objectPosition: "top center",
};

type ErrorPageIllustrationProps = {
  alt: string;
};

export default function ErrorPageIllustration(
  props: ErrorPageIllustrationProps
) {
  const { alt } = props;

  return <img src={Image404} alt={alt} style={illustrationStyle} />;
}
